var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComfort = function SvgComfort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m9.5 2.241.574-.621c2.024-2.16 5.409-2.16 7.411-.024 2.016 2.017 2.016 5.456.03 7.575-1.002 1.093-1.816 1.952-3.654 3.872-1.828 1.91-2.635 2.761-3.624 3.84l-.726.793-.738-.782-7.258-7.692C-.501 7.186-.501 3.746 1.493 1.62 3.513-.536 6.77-.536 8.93 1.625l.569.616H9.5Zm2.917 9.419c1.828-1.91 2.635-2.761 3.631-3.849 1.265-1.35 1.265-3.558 0-4.824a3.073 3.073 0 0 0-4.51-.005L9.5 5.19l-.735-.796L7.49 3.01c-1.343-1.344-3.3-1.344-4.537-.024-1.265 1.35-1.265 3.558-.003 4.822l6.543 6.933a298.64 298.64 0 0 1 2.925-3.082l-.001.001Z"
  })));
};
export default SvgComfort;